import cn from 'clsx';
import { PropsWithChildren } from 'react';

interface BoldHeadingProps extends PropsWithChildren {
  readonly extraClassName?: string;
}

export function BoldHeading({ extraClassName, children }: BoldHeadingProps) {
  return (
    <h2
      className={cn(
        'font-heading break-words m-0 font-bold text-xl',
        extraClassName,
      )}
    >
      {children}
    </h2>
  );
}
